import { useEffect, useState } from "react";

// ref: https://developer.mozilla.org/ja/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
export function useDataUrlFromBlob(blob: Blob | null): string | null {
  const [data, setData] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setData(null);
      return;
    }
    (async () => {
      const d = await readBlobAsDataUrl(blob);
      setData(d);
    })();
  }, [blob]);

  return data;
}

export function readBlobAsDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result as string));
    reader.addEventListener("error", reject);
    reader.readAsDataURL(blob);
  });
}
